import { render } from "./DownloadImgDialog.vue?vue&type=template&id=e53c9794&scoped=true"
import script from "./DownloadImgDialog.vue?vue&type=script&lang=js"
export * from "./DownloadImgDialog.vue?vue&type=script&lang=js"

import "./DownloadImgDialog.vue?vue&type=style&index=0&id=e53c9794&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e53c9794"]])

export default __exports__